export const getClosestIndex = (values: number[], target: number): number => {
  if (values.length === 0) return 0;

  let closestIndex = 0;
  for (let i = 1; i < values.length; i++) {
    const current = values[i] as number;
    const closest = values[closestIndex] as number;
    if (Math.abs(current - target) < Math.abs(closest - target)) {
      closestIndex = i;
    }
  }

  return closestIndex;
};
